import React, { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';
import { useT } from '../utils/translate';

// Internet aloqasi uzilganda ekranning eng tepasida doim ko'rinadigan ingichka
// chiziq — brauzerning o'zidagi online/offline hodisalariga asoslangan (qo'shimcha
// so'rov yubormaydi). Har joyda (login sahifasi ham) ko'rinishi uchun App.js'da
// eng tashqi darajada, marshrutlashdan mustaqil holda joylashtiriladi.
export default function OfflineBanner() {
  const t = useT();
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div className="fixed top-0 inset-x-0 z-[100] safe-top bg-red-600 text-white flex items-center justify-center gap-2 py-1.5 px-3 text-xs sm:text-sm font-medium shadow-md">
      <WifiOff className="w-3.5 h-3.5 shrink-0" />
      <span>{t('offline.title')}</span>
    </div>
  );
}
